/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class SettlementRules extends Mb {
    constructor() {
        super();
        this.baseUrl += '/enterpriseSettlementRules';
    }

    data({ settlementRulesName, remarks, isAvailable, isDefault, enterpriseId, currentPage, pageSize } = {}) {
        return super.get('/data', {
            settlementRulesName,
            remarks,
            isAvailable,
            isDefault,
            enterpriseId,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, enterpriseId, settlementRulesName, isAvailable, isDefault, remarks, skuJson } = {}) {
        return super.post('/save', {
            id,
            enterpriseId,
            settlementRulesName,
            isAvailable,
            isDefault,
            remarks,
            skuJson,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isDefault } = {}) {
        return super.post('/status', {
            id,
            isDefault,
        });
    }

    isAvailableStatus({ id, isAvailable } = {}) {
        return super.post('/isAvailableStatus', {
            id,
            isAvailable,
        });
    }
}

export default new SettlementRules();
export { SettlementRules };
